<template>
</template>

<script>
    import ButtonControlMixin from '../mixins/ButtonControlMixin';
    import { fromLonLat }       from 'ol/proj';
    import { EVENTS } from '@/app/shared/utils/constants';

    export default {
        mixins: [
            ButtonControlMixin
        ],
        props:{
            enableMyGeoLocationOcurrence:{
                type:Boolean,
                default: false
            },
            eventMyGeolocationCoordinates: {
                type: String,
                default: EVENTS.MY_GEO_LOCATION_COORDINATES,
            },
        },
        data() {
            return {
                idPanel: 'geolocation',
                className: 'ol-geolocation',
            }
        },
        methods: {
            addButtonMap: function(_map){
                let btn = _map.createBtnImg(
                    this.assetsPathTheme('/map/geolocation.svg'),
                    _map.getControlClassName(this.orderClassName),
                    this.title,
                    [
                        {
                            type: 'click',
                            event: () => {
                                const successCallback = (position) => {
                                    const crd = position.coords;
                                    const coords = fromLonLat(
                                        [crd.longitude, crd.latitude],
                                        _map.getOLMap().getView().getProjection()
                                    );   
                                    if(this.enableMyGeoLocationOcurrence){
                                        this.$eventBus.publish(this.moduleCode, this.eventMyGeolocationCoordinates,coords);
                                    }                                              
                                    _map.getOLMap().getView().animate({center: coords, zoom:7});
                                };

                                const errorCallback = (error) => {
                                    console.warn(`Geolocation ERROR (${error.code}): ${error.message}`);
                                    let msg = `${this.idPanel}.errors.default`;
                                    switch (error.code) {
                                        case 1: // PERMISSION_DENIED
                                            msg = `${this.idPanel}.errors.permission_denied`;
                                            break;
                                        case 2: // POSITION_UNAVAILABLE
                                            msg = `${this.idPanel}.errors.position_unavailable`;
                                            break;
                                        case 3: // TIMEOUT
                                            msg = `${this.idPanel}.errors.timeout`;
                                            break;
                                        default:
                                            break;
                                    }
                                    this.showError(this.$t(`${msg}`));
                                };
                                if (navigator.geolocation) {
                                    const options = {
                                        enableHighAccuracy: true,
                                        timeout: 10000, //(in milliseconds)
                                    };
                                    navigator.geolocation.getCurrentPosition(
                                        successCallback,
                                        errorCallback,
                                        options
                                    );
                                } else {
                                    // Browser doesn't support Geolocation
                                    this.showWarning(this.$t(`${this.idPanel}.errors.not_supported`));
                                }
                            }
                        }
                    ],
                    this.lblBtn
                );
                _map.addControl(this.posBtnMap, btn);
                return btn;
            },
        }

    }
</script>

<style lang="scss" scoped>
</style>